import React from "react";
import SocialMediaLinks from "./components/SocialMediaLinks";
import SvgBackground from "./components/SvgBackground";
import "./Frontpage.css";
import TypeWriterEffect from "react-typewriter-effect";

function Frontpage() {
  return (
    <>
      <div className="profile-container" id="home_page">
        <div className="profile-parent">
          <div className="profile-details">
            <div className="profile-details-name">
              <p className="primary-text">
                Hello, I'M
                <span className="highlighted-text">Shuvam Halder</span>
              </p>
            </div>
            <div className="profile-details-role">
              <span className="primary-text">
                <h1 style={{ display: "flex", gap: "6px" }}>
                  I am into
                  <span style={{ color: "#6d28d9" }}>
                    <TypeWriterEffect
                      multiTextLoop
                      cursorColor="#f3f4f6"
                      multiText={[
                        "Frontend Development",
                        "Competitive Programming",
                        "Python Development",
                      ]}
                      multiTextDelay={1000}
                      typeSpeed={100}
                    />
                  </span>
                </h1>
                <span className="profile-role-tagline">
                  4th Year IT Grad from Calcutta Institute of Engineering and Management.
                  A tech enthusiast,always fascinated by the tech,trying to make a statement
                  among the billions of other coders.
                </span>
              </span>
              <div className="colz">
                <SocialMediaLinks />
              </div>
            </div>

            <div className="profile-options">
              <a href="#contact_page">
                <button className="btn primary-btn">Hire Me</button>
              </a>
              <a href="./shuvam.pdf" download>
                <button className="btn highlighted-btn">Download CV</button>
              </a>
              <a href="https://calendly.com/d/2nc-nnj-24f/shuvamhalder">
                <button className="btn primary-btn">Book 1:1 Call</button>
              </a>
            </div>
          </div>
          <div className="profile-picture">
            <div className="profile-picture-background"></div>
          </div>
        </div>
        <SvgBackground />
      </div>
    </>
  );
}

export default Frontpage;
